import { IAccountListTableLang } from '../../../types/lang'

export const accountListTableLang: IAccountListTableLang = {
	account_list_table: {
		column_id: 'ID',
		column_email: 'Email',
		column_login: 'Login',
		column_kt_group: 'KT Group',
		column_role: 'Role',
		column_is_buyer: 'Buyer',
		column_in_group: 'Group',
		column_is_team: 'Team',
		column_is_active: 'Active',
		column_is_fired: 'Fired',
		column_date_registered: 'Date Registered',
		column_date_deleted: 'Date Deleted',
	}
}